import { type FC } from 'react';
import PrivacyChoicesIcon from 'src/components/PrivacyChoicesIcon';
import { useIsOneTrustLoaded } from 'src/containers/ConsentManager/ConsentManager';
import styled from 'threads5/styles/styled';
import SxProps from 'threads5/themes/sx-props';
import type { ITheme } from 'threads5/themes/theme';

const StyledOneTrustButton = styled('button')({
  padding: 0,
  margin: 0,
  border: 'none',
  transition: 'color 0.1s ease-in-out',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  fontWeight: '600',
  svg: {
    width: 'auto',
    height: '20px',
  },
});

const OneTrustButton: FC<{ sx?: SxProps<ITheme> }> = ({ sx }) => {
  const isOneTrustLoaded = useIsOneTrustLoaded();

  if (!isOneTrustLoaded) {
    return null;
  }

  return (
    <StyledOneTrustButton
      onClick={() => {
        window.OneTrust.ToggleInfoDisplay();
      }}
      sx={sx}
    >
      Your Privacy Choices
      <PrivacyChoicesIcon />
    </StyledOneTrustButton>
  );
};

export default OneTrustButton;
